/**
 * PlayButton Component
 * Button to trigger play simulation
 * Requirements: 5.1, 5.4
 */

import { PlayButtonProps } from '../types';
import './PlayButton.css';

function PlayButton({ onClick, isPlaying, disabled = false }: PlayButtonProps) {
  const buttonText = isPlaying ? 'Playing...' : 'Run Play';
  const isDisabled = disabled || isPlaying;

  return (
    <button
      className={`play-button ${isPlaying ? 'playing' : ''}`}
      onClick={onClick}
      disabled={isDisabled}
      aria-label={isPlaying ? 'Simulation in progress' : 'Start play simulation'}
      type="button"
    >
      <span className="play-icon">{isPlaying ? '⏸' : '▶'}</span>
      <span className="play-text">{buttonText}</span>
    </button>
  );
}

export default PlayButton;
